/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InscriptionAbandonDto
 */
export interface InscriptionAbandonDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof InscriptionAbandonDto
     */
    idsinscription?: Array<number> | null;
    /**
     * 
     * @type {Date}
     * @memberof InscriptionAbandonDto
     */
    dateAbandon?: Date;
}

/**
 * Check if a given object implements the InscriptionAbandonDto interface.
 */
export function instanceOfInscriptionAbandonDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InscriptionAbandonDtoFromJSON(json: any): InscriptionAbandonDto {
    return InscriptionAbandonDtoFromJSONTyped(json, false);
}

export function InscriptionAbandonDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InscriptionAbandonDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsinscription': !exists(json, 'idsinscription') ? undefined : json['idsinscription'],
        'dateAbandon': !exists(json, 'dateAbandon') ? undefined : (new Date(json['dateAbandon'])),
    };
}

export function InscriptionAbandonDtoToJSON(value?: InscriptionAbandonDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsinscription': value.idsinscription,
        'dateAbandon': value.dateAbandon === undefined ? undefined : (value.dateAbandon.toISOString()),
    };
}

